module.exports = __webpack_public_path__ + "fd4a9ebf045fdb24c7c90fec0254b6ab.MP3";